export async function drainQueue(io) {
    const results = new Map();
    const blocked = new Set();
    const queue = (await io.read()).sort((a, b) => (a.value.queuedAt ?? 0) - (b.value.queuedAt ?? 0) ||
        (a.value.command.expectedVersion ?? 0) -
            (b.value.command.expectedVersion ?? 0) ||
        a.key.localeCompare(b.key));
    for (const entry of queue) {
        const command = entry.value.command;
        const dependencies = [
            command.entityId,
            command.configId,
            command.payload?.receiptId,
            ...(command.payload?.allocations ?? []).map((a) => a.countId),
        ].filter(Boolean);
        if (["Needs resolution", "Retained retry"].includes(entry.value.state) ||
            dependencies.some((id) => blocked.has(id))) {
            blocked.add(command.entityId);
            continue;
        }
        try {
            const result = await io.send(command);
            if (result.retainedRetry) {
                await io.save({ ...entry, value: { ...entry.value, state: "Retained retry", error: "Preserved as a retry; no additional linen counted." } });
                blocked.add(command.entityId);
                results.set(command.requestId, result);
                continue;
            }
            await io.remove(entry.key);
            results.set(command.requestId, result);
        }
        catch (err) {
            // Transport loss, expired authority, throttling and server outages are retryable.
            // Never turn a temporary outage into a permanent record conflict.
            if (!err.status ||
                err.status === 401 ||
                err.status === 403 ||
                err.status === 408 ||
                err.status === 429 ||
                err.status >= 500)
                return { results, paused: err };
            await io.save({
                ...entry,
                value: {
                    ...entry.value,
                    state: "Needs resolution",
                    error: err.message,
                    conflictId: err.data?.conflictId,
                },
            });
            results.set(command.requestId, { error: err.message });
            blocked.add(command.entityId);
        }
    }
    return { results, paused: undefined };
}
